import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueTheMask from "vue-the-mask";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueClickOutside from "v-click-outside";
import { LINKS } from "./constants/links";
Vue.use(VueTheMask);
Vue.use(VueClickOutside);

Vue.config.productionTip = false;

Vue.component("Loading", Loading);

// Добавляем ссылки в глобальные свойства Vue
Vue.prototype.$links = LINKS;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
